import { defineComponent as _defineComponent } from 'vue'
import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createElementVNode as _createElementVNode, unref as _unref, normalizeClass as _normalizeClass, createCommentVNode as _createCommentVNode, createBlock as _createBlock, toDisplayString as _toDisplayString, normalizeStyle as _normalizeStyle, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-6c411688"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "portrait" }
const _hoisted_2 = ["srcSet", "type"]
const _hoisted_3 = ["alt", "src"]
const _hoisted_4 = ["srcSet", "type"]
const _hoisted_5 = ["src"]
const _hoisted_6 = {
  key: 1,
  class: "removeOverlay"
}

import { computed } from "vue"
	import { ConstellationBadge, ElementBadge } from "@/components"
	import { useJsonDataStore } from "@/stores"

	
export default /*#__PURE__*/_defineComponent({
  __name: 'CharacterCard',
  props: {
    characterId: {},
    clickable: { type: Boolean },
    hoverIntention: {},
    namePlaceholder: {},
    notCollected: { type: Boolean }
  },
  setup(__props: any) {

	const jsonData = useJsonDataStore()
	const props = __props

	const meta = computed(() => (
		props.characterId
			? jsonData.characters[props.characterId]
			: undefined
	))

	const srcList = computed(() => {
		return ["webp", "png"].map((ext) => ({
			mime: `image/${ext}`,
			path: meta.value
				? `${process.env.VUE_APP_GENSHINDEV_API}/characters/${meta.value?.key}/icon.${ext}`
				: `${process.env.VUE_APP_ASSETS_ENDPOINT}portraits/undefined.${ext}`,
		}))
	})

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("figure", {
    class: _normalizeClass({ owned: !_ctx.notCollected }),
    style: _normalizeStyle({ cursor: _ctx.clickable ? 'pointer' : 'default' })
  }, [
    _createElementVNode("picture", _hoisted_1, [
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(srcList.value, (src) => {
        return (_openBlock(), _createElementBlock("source", {
          key: src.mime,
          srcSet: src.path,
          type: src.mime
        }, null, 8, _hoisted_2))
      }), 128)),
      _createElementVNode("img", {
        alt: meta.value?.name || 'Character placeholder',
        src: srcList.value.at(-1)?.path
      }, null, 8, _hoisted_3)
    ]),
    (_unref(jsonData).assets?.portraitBg.length)
      ? (_openBlock(), _createElementBlock("picture", {
          key: 0,
          class: _normalizeClass([meta.value?.background ?? 'grey', "bg"])
        }, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(jsonData).assets?.portraitBg, (src) => {
            return (_openBlock(), _createElementBlock("source", {
              key: src.type,
              srcSet: src.src,
              type: src.type
            }, null, 8, _hoisted_4))
          }), 128)),
          _createElementVNode("img", {
            src: _unref(jsonData).assets?.portraitBg.at(-1)?.src,
            alt: ""
          }, null, 8, _hoisted_5)
        ], 2))
      : _createCommentVNode("", true),
    ('remove' === _ctx.hoverIntention)
      ? (_openBlock(), _createElementBlock("div", _hoisted_6, " × "))
      : _createCommentVNode("", true),
    (meta.value)
      ? (_openBlock(), _createBlock(_unref(ElementBadge), {
          key: 2,
          elementId: meta.value.element
        }, null, 8, ["elementId"]))
      : _createCommentVNode("", true),
    (_ctx.characterId)
      ? (_openBlock(), _createBlock(_unref(ConstellationBadge), {
          key: 3,
          characterId: _ctx.characterId
        }, null, 8, ["characterId"]))
      : _createCommentVNode("", true),
    _createElementVNode("figcaption", null, _toDisplayString(meta.value?.name || props.namePlaceholder || "Empty"), 1)
  ], 6))
}
}

})